import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import ListaCestNcmService from "./listaCestNcmService"
import FormList from 'base/FormList'

export default function ListaCestNcmList() {

    const [service] = useState(() => new ListaCestNcmService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_lcn',
        dsName: 'descricao_lcn',
        mainField: { name: 'descricao_lcn', label: 'Descrição' },
        advFields: [
            { name: 'codigo_lcn', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'cod_tlcn_lcn', label: 'Tipo de lista', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_lcn', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_lcn" sortable header="Código"></Column>
            <Column field="descricao_lcn" sortable header="Descrição"></Column>
        </FormList >
    )
}
